import styled from '@emotion/styled';
import { Box, Grid } from '@mui/material';
import { useRouter, useSearchParams } from 'next/navigation';
import { ExperienceMode } from '@/generated/graphql';
import { ExperienceGrid } from './experience-grid';
import InPersonExperiences from './in-person-experiences';
import NewExploreInPersonMap from './new-explore-in-person-map';

const MainDiv = styled.div`
  width: 100%;
  height: auto;
  margin: 0;
  z-index: 1;
  margin-bottom: 100px;
  @media (max-width: 768px) {
    padding: 24px 0px 0 0;
    padding-bottom: 150px;
    margin-bottom: 150px;
  }
`;
const MapDiv = styled(Grid)`
  width: 100%;
  height: auto;
  margin: 0;
  direction: row;
  @media (max-width: 768px) {
    flex-direction: column-reverse;
  }
`;

const FilteredResults = () => {
  const searchParams = useSearchParams();
  const mode = searchParams?.get('mode');
  if (mode && mode === ExperienceMode.InPerson) {
    return (
      <>
        <MapDiv container direction="row" spacing={4}>
          <Grid item xs={12} sm={6} direction="column">
            <InPersonExperiences />
            <Box height="10vh" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <NewExploreInPersonMap />
          </Grid>
        </MapDiv>
      </>
    );
  } else {
    return (
      <MainDiv>
        <ExperienceGrid />
      </MainDiv>
    );
  }
};

export default FilteredResults;
